<template>
    <TableView :heading="__('Educational Qualification')"
        :headers="[
            { name: __('Educational Degree'), value: (row) => locale_attr(row, 'education_name_{lang}') },
            { name: __('Teacher'), value: (row) => en_to_bn(row.user_count) }
        ]"
        :rows="designations"
        :pagination="pagination"
        :loading="loading"
        @change:page="fetchCounts" />
</template>

<script>
import axios from 'axios';
import TableView from './TableView.vue';

export default {
    components: {
        TableView,
    },

    data() {
        return {
            designations: [],
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
                from: 0,
                to: 0,
            },
            loading: false,
        }
    },

    mounted() {
        this.observe_visibility(this.$el, () => this.fetchCounts());
    },

    methods: {
        async fetchCounts() {
            this.loading = true;
            await axios.get('/dashboard/education-wise-user-count', {
                params: { page: this.pagination.current_page },
            }).then(({ data }) => {
                this.designations = data.counts.collection;
                this.pagination = data.counts.pagination;
            }).catch(console.error);

            this.loading = false;
        },
    },
}
</script>